import { z } from 'zod';

export const chatAttachmentSchema = z.object({
  documentId: z.string(),
  fileName: z.string(),
  fileType: z.string(),
  /** Ignored by the server since THI-198 — the API resolves the file from
   *  `documentId` within the caller's org and signs its own read URL. Kept
   *  optional so older clients that still send it are not rejected. */
  fileUrl: z.string().url().optional(),
});

export const chatMessageSchema = z.object({
  message: z.string().min(1).max(5000),
  threadId: z.string().nullable().optional(),
  attachments: z.array(chatAttachmentSchema).max(5).optional(),
});

export type ChatMessageInput = z.infer<typeof chatMessageSchema>;
export type ChatAttachmentInput = z.infer<typeof chatAttachmentSchema>;

export const classifierSchema = z.object({
  domain: z.enum(['invoice', 'client', 'general']).describe(
    "The domain of the user's intent"
  ),
});

export type ClassifierOutput = z.infer<typeof classifierSchema>;

export const invoiceArtifactSchema = z.object({
  invoiceDraft: z.object({
    clientId: z.string(),
    items: z.array(z.object({
      description: z.string(),
      quantity: z.number(),
      unitPrice: z.number(),
    })).min(1),
    taxRate: z.number().min(0).max(100),
    depositAmount: z.number().min(0),
    dueDate: z.string().datetime().nullable().optional(),
    notes: z.string().nullable().optional(),
  }),
  matchedClient: z.object({
    id: z.string(),
    name: z.string(),
    email: z.string().nullable(),
    zaloPhone: z.string().nullable(),
  }).nullable(),
  missingFields: z.array(z.string()),
});

export type InvoiceArtifact = z.infer<typeof invoiceArtifactSchema>;
